$(function() {
	var redirect = parseInt($('#redirect').val());

	if (redirect) {
		var iOS = navigator.userAgent.match(/(iPad|iPhone|iPod)/i) ? true : false;
		if (iOS) {
			window.location.href = '/mobile/ios.html';
			window.location = 'https://itunes.apple.com/br/app/d-tália-nova-mutum/id1511758364';
		}
		var ua = navigator.userAgent.toLowerCase();
		var isAndroid = ua.indexOf('android') > -1;
		if (isAndroid) {
			window.location = 'https://play.google.com/store/apps/details?id=com.pizzariadtalia';
		}
	}
});
